/* @ngInject */
const axletreeResource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.axletree}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'post': {
      method: 'POST',
    },
  }
  )
}
export default axletreeResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/resource.service.js